/* istanbul ignore file */
import { BackboneSchema as backboneSchema } from '@bingads-webui/backbone-schema';
import { getHotelCenterService } from '@bingads-webui-campaign/hotel-center-service';
import _ from 'underscore';

export const getSubAccountModel = ({
  state, i18n, subAccountSchema, jsdata, edm,
}) => {
  if (!i18n || !subAccountSchema || !state || !jsdata || !edm) {
    return {};
  }
  const { AccountService } = getHotelCenterService({ state, jsdata, edm });
  // eslint-disable-next-line no-param-reassign
  subAccountSchema.properties.Name.required = true;
  const SchemaModel = backboneSchema(subAccountSchema, i18n, ['Name']);

  /**
   * Sub account backbone model based on schema
   * @extends Backbone.Model
   */

  class SubAccountModel extends SchemaModel {
    initialize(options = {}) {
      if (options.Id) {
        this.id = options.Id;
      }
    }

    get idAttribute() {
      return 'Id';
    }

    toJSON() {
      const json = super.toJSON();

      this.attachNestedModels(json, ['DailyBudget', 'MaximumBid', 'Bid', 'BidMultipliers', 'HotelAssociationCount']);

      return json;
    }

    sync(method, model, options) {
      const json = model.toJSON();

      this.accountService = new AccountService();

      switch (method) {
        case 'read':
          return this.accountService.fetchSubAccountAsync()
            .then((subAccount) => {
              // For V1, there is only one fixed account with one sub-account
              if (subAccount) {
                this.parse(subAccount);
                this.set('Id', subAccount.Id);

                // to do [rayduan]: add support for nested models in backbone-model
                this.set('DailyBudget', subAccount.DailyBudget);
                this.set('MaximumBid', subAccount.MaximumBid);
                this.set('Bid', subAccount.Bid);
                this.set('BidMultipliers', subAccount.BidMultipliers);
                this.set('HotelAssociationCount', subAccount.HotelAssociationCount);
              }
            });
        case 'create':
          return jsdata.SubAccount.create(json, { cacheResponse: false });
        case 'patch':
        case 'update':
        {
          if (_.has(json, 'Bid') && json.Bid.Amount === null) {
            json.Bid = null; // if user didn't input Bid amout, pass null object to odata
          }
          const updatedId = model.get('Id') || model.id;
          const subAccountModel = state.get('subAccount_model');

          // if the updated subaccount Id equal current global subaccount model in state
          // updated the status for subaccout model
          if (subAccountModel && subAccountModel.Id === updatedId) {
            state.unset('subAccount_model');
          }
          return jsdata.SubAccount.update(
            updatedId,
            _.isEmpty(options.attrs) ? json : _.pick(json, options.attrs),
            { cacheResponse: false }
          );
        }
        case 'delete':
          return jsdata.SubAccount.destroy(model.id, {
            entitySet: this.entitySet,
          });
        default:
          throw new Error(`sync method ${method} is not supported`);
      }
    }

    attachNestedModels(json, fieldNames) {
      _.each(fieldNames, (field) => {
        if (this.has(field) || _.contains(this.changedAttributes(), 'MaximumBid')) {
          json[field] = this.get(field); // eslint-disable-line
        }
      });
    }
  }

  return {
    SubAccountModel,
  };
};
